import {Injectable} from '@angular/core';
import {SaleModel} from '../../api/entity/sale.model';
import {SaleRepository} from './ngrx/Sale.repository';
import {SaleDataServiceAdapter} from './ngrx/SaleDataService.adapter';
import {AbstractSearchService} from '../../../core/service/v2/service/search/abstractSearch.service';


@Injectable()
export class SaleSearchByPartnerIdService
    extends AbstractSearchService<SaleModel, SaleModel>{
    constructor(repository: SaleRepository, dataServiceAdapter: SaleDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

}
